import { InfiniteData } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { TimelineEventItem, TimelineEventListPaginated } from 'types/Timeline';
import { ucfirst } from 'utils/text';

export const faltPaginatedTimelineDataAndSort = (
	data?: InfiniteData<TimelineEventListPaginated>
): TimelineEventItem[] => {
	return (
		data?.pages
			.map((page) => page.items)
			.flat()
			.sort((a, b) => ((a.startAt || a.dayDate) < (b.startAt || b.dayDate) ? -1 : 1)) || []
	);
};

type TimelineEventGroup = {
	key: string;
	name: string;
	items: TimelineEventItem[];
};

export const groupTimelineData = (flatData?: TimelineEventItem[]) => {
	const currentYear = new Date().getFullYear();
	return (
		flatData?.reduce<TimelineEventGroup[]>((current, item) => {
			const monthYearIndex = dayjs(item.startAt || item.dayDate).format('YYYY-MM');
			const findedIndex = current.findIndex(({ key }) => key === monthYearIndex);

			if (findedIndex === -1) {
				const year = new Date(item.dayDate).getFullYear();
				const namedMonth = dayjs(item.startAt || item.dayDate).format('MMMM');
				const name = `${ucfirst(namedMonth)}${year !== currentYear ? ` ${year}` : ''}`;

				current.push({
					key: monthYearIndex,
					name,
					items: [item],
				});
			} else {
				current[findedIndex].items.push(item);
			}

			return current;
		}, []) || []
	);
};
